module.exports = __webpack_public_path__ + "static/media/the_cauldron_ic_pg.9639964e.svg";